import React from 'react';
import { useDefaultQuality } from '../../../hooks/useDefaultQuality';
import { useQualityControl } from '../../../hooks/useQualityControl';
import { useSessionStore } from '@/hooks/useSessionStore';

const QualityInput: React.FC = () => {
  const defaultQuality = useDefaultQuality();
  const sessionStore = useSessionStore();
  const { session } = sessionStore;
  const { value, toggleQuality } = useQualityControl(defaultQuality, session);

  return (
    <div className="flex flex-col">
      <span className="text-[10px] text-[#9D9DA6] uppercase">QUALITY</span>
      <span onClick={toggleQuality} className="text-[#9D9DA6] underline cursor-pointer hover:text-jen-orange transition-colors">
        .{value}
      </span>
    </div>
  );
};

export default QualityInput;
